import { Component, Input } from '@angular/core';

@Component({
  selector: 'base-app-loader',
  standalone: true,
  imports: [],
  templateUrl: './app-loader.component.html',
  styleUrl: './app-loader.component.css',
})
export class AppLoader {
  @Input() loading: boolean = false;
  @Input() roundLoader: boolean = false;
}
